export default __webpack_public_path__ + "static/media/Graphics_Long-Sleeve-Shirt-Mock-Up-min.b6ca0806.png";